import config from '@project/config';
import { PaginatedNameFilterOptions } from '@project/types';

const baseUrl = `${config.apiUrl()}/BackOffice/Partners`;

export default {
  getBaseUrl: (): string => `${baseUrl}`,
  deleteUrl: (leadPartnerId: string) => `${baseUrl}/${leadPartnerId}`,
  updateStatusUrl: (leadPartnerId: string) => `${baseUrl}/${leadPartnerId}/status`,
  getPaginatedBlackListUrl: (filterOptions: PaginatedNameFilterOptions) =>
    `${baseUrl}?PageNumber=${filterOptions.pageNum}&PageSize=${filterOptions.pageEntries}&Name=${filterOptions.name}`,
};
